export default __webpack_public_path__ + "static/media/female_04.0c5032a6.png";